import { render, staticRenderFns } from "./trial.vue?vue&type=template&id=33fe2ab2&scoped=true"
import script from "./trial.vue?vue&type=script&lang=js"
export * from "./trial.vue?vue&type=script&lang=js"
import style0 from "./trial.vue?vue&type=style&index=0&id=33fe2ab2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fe2ab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33fe2ab2')) {
      api.createRecord('33fe2ab2', component.options)
    } else {
      api.reload('33fe2ab2', component.options)
    }
    module.hot.accept("./trial.vue?vue&type=template&id=33fe2ab2&scoped=true", function () {
      api.rerender('33fe2ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/mobilePreview/components/trial.vue"
export default component.exports